export default __webpack_public_path__ + "static/media/editorPopUpWarning.3e298c6e.svg";